import { render, staticRenderFns } from "./StackedColumnChartMensal.vue?vue&type=template&id=2e344fc9&"
import script from "./StackedColumnChartMensal.vue?vue&type=script&lang=js&"
export * from "./StackedColumnChartMensal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports